/**
 * Centralized API base URL for the new auth + dashboard backend.
 * Used in src/api/api.tsx.
 *
 * Defaults to production. To run against another backend — e.g. the local .NET App on
 * http://localhost:5050 — set `REACT_APP_API_BASE_URL` in `.env.development.local`
 * (gitignored). CRA inlines it at build time, and only `npm start` reads that file, so
 * production builds (CI never sets the variable) always keep the default.
 */
const PRODUCTION_API_BASE_URL = "https://api.valyrion.com/";

export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL?.trim() || PRODUCTION_API_BASE_URL;

// A local dev server on the default talks to production data — say so where developers look.
if (process.env.NODE_ENV === "development" && API_BASE_URL === PRODUCTION_API_BASE_URL) {
  console.warn(
    `[api] Dev server is using the PRODUCTION API (${PRODUCTION_API_BASE_URL}). ` +
      "Set REACT_APP_API_BASE_URL in .env.development.local to use another backend."
  );
}
